import { BasicParallelEnumerable } from "../BasicParallelEnumerable.js";
export const prepend = (source, element) => {
    const dataFunc = source.dataFunc;
    switch (dataFunc.type) {
        case 1: {
            const generator = () => {
                const array = dataFunc.generator();
                array.unshift(Promise.resolve(element));
                return array;
            };
            return new BasicParallelEnumerable({
                generator,
                type: dataFunc.type,
            });
        }
        case 2: {
            const generator = async () => {
                const array = await dataFunc.generator();
                array.unshift(Promise.resolve(element));
                return array;
            };
            return new BasicParallelEnumerable({
                generator,
                type: dataFunc.type,
            });
        }
        case 0: {
            const generator = async () => {
                const array = await dataFunc.generator();
                array.unshift(element);
                return array;
            };
            return new BasicParallelEnumerable({
                generator,
                type: dataFunc.type,
            });
        }
    }
};
